export default {
      id: "paper-usage",
      viewBox: "0 0 18 18",
      url: "/assets/" + "icons.svg#paper",
      toString: function () {
        return this.url;
      }
    }